import React from 'react';

import { useDynamicString } from '../../hooks/useDynamicValue.tsx';
import type { A2UIComponentDefinition } from '../../types/A2UIComponents.types.tsx';
import type { A2UIVideoProps } from '../../types/A2UIComponents.types.tsx';

type Props = {
	definition: A2UIComponentDefinition;
};

export const A2UIVideo = ({ definition }: Props): React.JSX.Element => {
	const def = definition as A2UIVideoProps;
	const url = useDynamicString(def.url);
	const label = def.accessibility?.label ?? '';

	return (
		// eslint-disable-next-line jsx-a11y/media-has-caption, @atlaskit/ui-styling-standard/enforce-style-prop
		<video src={url} controls aria-label={label} style={{ maxWidth: '100%' }}>
			<track kind="captions" />
		</video>
	);
};
